import { useEffect, useState } from 'react';

// Hooks
import useActiveSocialProfile from '@/hooks/user/useActiveSocialProfile';

export const SP_TRANSITION_DURATION_MS = 500;

let delayTimer;

const useSocialProfileTransition = () => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const [transitionInProgress, setTransitionInProgress] = useState(false);

    useEffect(() => {
        if (delayTimer) {
            clearTimeout(delayTimer);
        }
        setTransitionInProgress(true);
        delayTimer = setTimeout(() => {
            setTransitionInProgress(false);
        }, SP_TRANSITION_DURATION_MS + 100);

        return () => {
            if (delayTimer) {
                clearTimeout(delayTimer);
            }
        };
    }, [activeSocialProfile]);

    return { transitionInProgress };
};

export default useSocialProfileTransition;
